import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: theme.spacing(1.75),
        fontWeight: '600',
        lineHeight: theme.spacing(3),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    },
}));
//# sourceMappingURL=Chip.styles.js.map